{
  "required": "Required",
  "invalidEmail": "The Email format is invalid",
  "invalidPhoneNumber": "The phone number format is invalid",
  "email-kind-invalid": "Invalid kind for an Email",
  "invalid-uppercase": "Invalid uppercase"
}
